import React from 'react'
import BarbarianTrackerHexInactive from '@static/images/barbarian_tracker_hex_inactive.svg'
import BarbarianTrackerHexActive from '@static/images/barbarian_tracker_hex_active.svg'
import BarbarianTrackerHexAttack from '@static/images/barbarian_tracker_hex_attack.svg'
import {ImageURL} from '@colonist/types'

export const BARBARIAN_INVASION_TRACKER_HEX_PROPS_TYPES = ['inactive', 'active', 'attack'] as const
export type BarbarianTrackerHexPropsType = typeof BARBARIAN_INVASION_TRACKER_HEX_PROPS_TYPES[number]
export interface UIGameBarbarianInvasionTrackerHexProps {
    type: BarbarianTrackerHexPropsType
    className?: string
}

const HEX_TYPE_MAP: { [key in BarbarianTrackerHexPropsType]: ImageURL } = {
    inactive: BarbarianTrackerHexInactive,
    active: BarbarianTrackerHexActive,
    attack: BarbarianTrackerHexAttack,
}

export const UIGameBarbarianInvasionTrackerHex = ({
    type,
    className,
}: UIGameBarbarianInvasionTrackerHexProps) => (
    <img
        className={className}
        src={HEX_TYPE_MAP[type]}
    />
)
